{
  "AGENT_BOTS": {
    "HEADER": "Bots",
    "LOADING_EDITOR": "Loading editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT_BADGE": "System",
    "AVATAR": {
      "SUCCESS_DELETE": "Bot-avatar ble slettet",
      "ERROR_DELETE": "Feil ved sletting av bot-avatar, prøv igjen"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Bot name",
        "PLACEHOLDER": "Name your bot.",
        "ERROR": "Bot name is required."
      },
      "DESCRIPTION": {
        "LABEL": "Bot description",
        "PLACEHOLDER": "What does this bot do?"
      },
      "BOT_CONFIG": {
        "ERROR": "Please enter your CSML bot configuration above.",
        "API_ERROR": "Your CSML configuration is invalid. Please fix it and try again."
      },
      "SUBMIT": "Validate and save"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Select an agent bot",
      "DESC": "Assign an Agent Bot to your inbox. They can handle initial conversations and transfer them to a live agent when necessary.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Oppdater",
      "DISCONNECT": "Disconnect bot",
      "SUCCESS_MESSAGE": "Successfully updated the agent bot.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Successfully disconnected the agent bot.",
      "ERROR_MESSAGE": "Could not update the agent bot. Please try again.",
      "DISCONNECTED_ERROR_MESSAGE": "Could not disconnect the agent bot. Please try again.",
      "SELECT_PLACEHOLDER": "Select bot",
      "COUNTRY_BOTS": {
        "TITLE": "Roboter per land",
        "DESC": "Denne innboksen betjener flere land. En samtale går til boten for sitt land: etter Kaufland-butikken, markedsplassen til Allegro-bestillingen, eller ellers språket kunden skriver på. Alle andre samtaler går til standardboten ovenfor.",
        "COUNTRY": "Velg et land",
        "BOT": "Velg bot",
        "ADD": "Legg til bot for et land",
        "REMOVE": "Fjern",
        "DEFAULT_REQUIRED": "Velg en standardbot først. Et lands bot erstatter den bare for det landet.",
        "DISCONNECT_ALL": "Koble fra alle roboter"
      }
    },
    "ADD": {
      "TITLE": "Configure new bot",
      "CANCEL_BUTTON_TEXT": "Avbryt",
      "API": {
        "SUCCESS_MESSAGE": "Bot added successfully.",
        "ERROR_MESSAGE": "Could not add bot. Please try again later."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Configure new bot' button ↗",
      "LOADING": "Fetching bots...",
      "TABLE_HEADER": {
        "DETAILS": "Bot-detaljer",
        "URL": "Webhook-URL"
      },
      "TYPE": "Bot type"
    },
    "DELETE": {
      "BUTTON_TEXT": "Slett",
      "TITLE": "Delete bot",
      "CONFIRM": {
        "TITLE": "Bekreft sletting",
        "MESSAGE": "Er du sikker på at du vil slette {name}?",
        "YES": "Ja, slett",
        "NO": "Nei, behold"
      },
      "SUBMIT": "Slett",
      "CANCEL_BUTTON_TEXT": "Avbryt",
      "DESCRIPTION": "Are you sure you want to delete this bot? This action is irreversible.",
      "API": {
        "SUCCESS_MESSAGE": "Bot deleted successfully.",
        "ERROR_MESSAGE": "Could not delete bot. Please try again."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Rediger",
      "LOADING": "Fetching bots...",
      "TITLE": "Edit bot",
      "CANCEL_BUTTON_TEXT": "Avbryt",
      "API": {
        "SUCCESS_MESSAGE": "Bot updated successfully.",
        "ERROR_MESSAGE": "Could not update bot. Please try again."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Bot-avatar"
      },
      "NAME": {
        "LABEL": "Botnavn",
        "PLACEHOLDER": "Skriv inn botnavn"
      },
      "DESCRIPTION": {
        "LABEL": "Beskrivelse",
        "PLACEHOLDER": "Hva gjør denne boten?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Webhook-URL",
        "PLACEHOLDER": "https://example.com/webhook"
      },
      "ERRORS": {
        "NAME": "Botnavn er påkrevd",
        "URL": "Webhook-URL er påkrevd",
        "VALID_URL": "Skriv inn en gyldig URL som starter med http:// eller https://"
      },
      "CANCEL": "Avbryt",
      "CREATE": "Opprett bot",
      "UPDATE": "Oppdater bot"
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot",
      "CSML": "CSML bot"
    }
  }
}
